import { render, staticRenderFns } from "./indreporte-estudiante-pastel.vue?vue&type=template&id=ad55a442"
import script from "./indreporte-estudiante-pastel.vue?vue&type=script&lang=js"
export * from "./indreporte-estudiante-pastel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports